export enum OfferPeriodType {
    MONTHLY = 0,
    ANNUAL = 1
}